<template>
  <div class="my-data-table va-row" id="cards">
    <div class="flex xs12 no-padding fiscal-notes">
      <div class="body-spacing">
        <!-- Quando não tem livros -->
        <div class="va-row empty-area" v-if="books.length === 0">
          <div class="empty-box">
            <div class="empty-box-header">LIVROS</div>
            <div class="empty-box-body">
              <b>Nenhum livro cadastrado no momento.</b><br />
              Para solicitar um novo cadastro de livro envie um e-mail para:
              <a href="mailto:escolas@dentroeduca.com.br"
                >escolas@dentroeduca.com.br</a
              >
            </div>
          </div>
        </div>

        <!-- Quando tem livros -->
        <div class="va-row" v-else>
          <div class="sets-list table-list-simple va-row">
            <!-- Cabeçalho -->
            <div class="va-row header">
              <div class="flex item book">LIVROS</div>

              <!-- Só mostra coluna de quantidade se existir pelo menos 1 -->
              <div v-if="hasQuantities" class="flex item quantity">
                QUANTIDADE
              </div>

              <div v-if="hasQuantities" class="flex item action">AÇÃO</div>

              <!-- Total -->
              <!-- <div class="flex item" v-if="computedTotalQuantity">
                TOTAL ({{ computedTotalQuantity }} un.)
              </div> -->
            </div>

            <!-- Campo de pesquisa -->
            <!-- <div class="search flex md12 xs12 text-center">
							<input
								class="filterProducts"
								type="text"
								v-model="search"
								placeholder="Pesquisar nome do livro"
							/>
						</div> -->

            <!-- Lista de livros -->
            <div class="products-list">
              <div class="va-row">
                <div class="lines" v-for="item in filteredBooks" :key="item.id">
                  <div class="va-row">
                    <!-- Capa -->
                    <div class="flex md1 item book-cover padding-list-book">
                      <img :src="item.thumbnail" alt="" width="136" />
                    </div>

                    <!-- Nome e descrição -->
                    <div
                      :class="[
                        'item text-left book-content',
                        hasQuantities ? 'flex md7' : 'flex md8',
                      ]"
                    >
                      <div>
                        <h4>
                          <span class="nome-da-marca">{{
                            item.brand.name
                          }}</span
                          ><br />
                          {{ item.name }}
                        </h4>
                        <div
                          class="description align-text-description md2"
                          v-html="item.contentText2"
                        ></div>
                      </div>
                    </div>

                    <!-- Quantidade opcional -->
                    <div
                      v-if="hasQuantities"
                      class="flex md2 item book-quantity text-center"
                    >
                      {{ item.quantity || 0 }} unidades
                    </div>

                    <!-- Botão -->
                    <div class="flex md2 item action text-right">
                      <router-link
                        :to="{ name: 'manager-book', params: { book: item } }"
                        class="btn"
                      >
                        VISUALIZAR
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BooksList",
  props: {
    books: {
      type: Array,
      required: true,
    },
    totalQuantity: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      search: "",
    };
  },
  computed: {
    hasQuantities() {
      return this.books.some(
        (book) => book.quantity !== undefined && book.quantity !== null,
      );
    },
    computedTotalQuantity() {
      if (this.totalQuantity !== null) return this.totalQuantity;
      if (!this.hasQuantities) return null;
      return this.books.reduce((sum, b) => sum + (b.quantity || 0), 0);
    },
    filteredBooks() {
      return this.books.filter((book) =>
        book.name.toLowerCase().includes(this.search.toLowerCase()),
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.fiscal-notes {
  background-color: #ffffff;
  position: relative;
  border-radius: 16px;

  .body-spacing {
    padding: 0px;

    @media (max-width: 990px) {
      padding: 25px 15px 15px 15px;
    }
  }

  h4 {
    font-family: "Roboto";
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #68596e;
    margin: 0;
  }

  .books {
    width: 18% !important;
  }
  .book-name {
    width: 48% !important;
  }
  .book-quantity {
    width: 16% !important;
  }
  .book-action {
    width: 16% !important;
  }
}

.book {
  width: 66% !important;
}

.quantity {
  width: 16% !important;
}

.action {
  width: 18% !important;
  text-align: center;
}

.book {
  width: 66% !important;
}

.quantity {
  width: 16% !important;
}

.action {
  width: 18% !important;
  text-align: center;
}

.empty-area {
  padding: 33px 31px;

  .empty-box {
    width: 100%;
    border: 1px solid #dfdae4;
    border-radius: 16px;
    overflow: hidden;

    &-header {
      padding: 22px;
      background: #f4f2fb;
      border-bottom: 1px solid #dfdae4;
      font-family: "Roboto";
      font-weight: 700;
      font-size: 12px;
      text-transform: uppercase;
      color: #68596e;
    }

    &-body {
      font-family: "Roboto";
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      color: #68596e;
      padding: 24px;
    }
  }
}

.products-list {
  width: 100%;

  .book-cover img {
    max-width: 150px;
  }

  .book-content {
    padding-left: 24px !important;
  }
}

.book-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.nome-da-marca {
  font-family: "Roboto";
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #68596e;
}

.align-text-description {
  position: relative;
  top: 10px;
}

.lines {
  padding: 24px;
}

.padding-list-book {
  padding: 0px !important;
}

.filterProducts {
  display: block;
  width: 100%;
  height: 65px;
  padding-left: 20px;
  border-radius: 5px;
  border: 1px solid #dfdae4;
  font-family: Roboto;
  font-size: 16px;
  color: #000;
  background-color: transparent;
}

.filterProducts:focus {
  outline: none;
  border: 2px solid #4965bc;
  background-color: #ffffff;
}
</style>
